import { ITheme, theme } from "../../utils/theme";

export const workInfoTableStyle = {
  borderRightWidth: 1,
  borderRight: (theme: ITheme) => `1px solid ${theme.palette.grey[300]}`,
  borderLeft: (theme: ITheme) => `1px solid ${theme.palette.grey[300]}`,
  '& .MuiTableCell-root': {
    padding: { xs: 0, sm: 1 },
  },
  '& .MuiTableHead-root > .MuiTableRow-root .MuiTableCell-root': {
    minWidth: { xs: 'auto' }
  },
  '&.sx-small .MuiTable-root': {
    '& .MuiTableRow-root .MuiTableCell-root': {
      borderBottom: 'none',
      padding: 0.4,
      '& .MuiTypography-root': {
        fontSize: { xs: '0.85rem', sm: '16px' }
      }
    },
  },
  '& .MuiTable-root .MuiTableRow-root .MuiTableCell-root:first-of-type': {
    color: (theme: ITheme) => theme.palette.blue[700],
    width: '50%',
    borderRight: 'none',
  },
  '& .MuiTable-root .MuiTableRow-root .MuiTableCell-root:last-of-type': {
    color: (theme: ITheme) => theme.palette.red[900],
    width: '50%',
    borderRight: 'none',
  },
  '& .MuiTableCell-root:first-of-type .MuiTable-root .MuiTableRow-root .MuiTableCell-root:first-of-type': {
    color: theme.palette.corporateBlue,
  },
  '& .MuiTableRow-root.oddRow .MuiTableCell-root': {
    background: (theme: ITheme) => theme.palette.blue[100],
  },
  '& .MuiTableRow-root > .MuiTableCell-root': {
    borderRight: (theme: ITheme) => `1px solid ${theme.palette.grey[300]}`,
  },
  '& .MuiTableRow-root .MuiTableCell-root': {
    background: 'white',
  },
  '& .disabled .MuiTableCell-root:first-of-type .MuiTable-root .MuiTableRow-root .MuiTableCell-root:first-of-type': {
    color: (theme: ITheme) => theme.palette.grey[50],
  },
  '& .disabled .MuiTable-root .MuiTableRow-root .MuiTableCell-root:first-of-type': {
    color: (theme: ITheme) => theme.palette.grey[50],
  },
  '& .disabled .MuiTable-root .MuiTableRow-root .MuiTableCell-root:last-of-type': {
    color: (theme: ITheme) => theme.palette.grey[50],
  },
  '& .subCategory.MuiTableRow-root .MuiTableCell-root': {
    background: (theme: ITheme) => theme.palette.success.main,
  },
  '& .subCategory .MuiTableCell-root:first-of-type .MuiTable-root .MuiTableRow-root .MuiTableCell-root:first-of-type': {
    paddingLeft: 2,
  },
}